// import React, { useEffect, useState } from "react";
// import { IoMdClose } from "react-icons/io";
// import searchIcon from "./../../../Assets/icons/searchicon.svg";

// const SearchInput = ({
//   placeholder = "Search...",
//   onSearch = () => {},
//   searchTerm,
//   setSearchTerm = () => {},
// }) => {
//   const [displayValue, setDisplayValue] = useState("");

//   useEffect(() => {
//     if (searchTerm.length > 20) {
//       setDisplayValue(searchTerm.slice(0, 20) + "...");
//     } else {
//       setDisplayValue(searchTerm);
//     }
//   }, [searchTerm]);

//   const handleSearchInputChange = (event) => {
//     setSearchTerm(event.target.value);
//   };

//   const clearSearchAndFetch = () => {
//     setSearchTerm("");
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter") {
//       onSearch();
//     }
//   };

//   const handleSearchClick = () => {
//     onSearch();
//   };

//   return (
//     <div className="searchinput-wrapper">
//       <div className="searchinput-container">
//         <input
//           type="text"
//           className="searchinput"
//           placeholder={placeholder}
//           value={displayValue}
//           onChange={handleSearchInputChange}
//           onKeyDown={handleKeyPress}
//         />
//         {searchTerm ? (
//           <IoMdClose
//             size={22}
//             className="searchinput-close-icon"
//             onClick={clearSearchAndFetch}
//           />
//         ) : (
//           <img src={searchIcon} alt="Search" className="searchinput-icon" />
//         )}
//       </div>
//       <div>
//         <div
//           onClick={handleSearchClick}
//           className="flte-btnnn"
//           style={{ borderRadius: "38px", cursor: "pointer" }}
//         >
//           Search
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SearchInput;
import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import searchIcon from "./../../../Assets/icons/searchicon.svg";

const SearchInput = ({
  placeholder = "Search...",
  onSearch = () => {},
  searchTerm,
  setSearchTerm = () => {},
  showSearchButton = true,
}) => {
  const [displayValue, setDisplayValue] = useState("");
  const [isClearing, setIsClearing] = useState(false);

  useEffect(() => {
    if (searchTerm?.length > 30) {
      setDisplayValue(searchTerm.slice(0, 30) + "...");
    } else {
      setDisplayValue(searchTerm || "");
    }
  }, [searchTerm]);

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const clearSearchAndFetch = () => {
    setSearchTerm("");
    setIsClearing(true);
  };

  useEffect(() => {
    if (isClearing && searchTerm === "") {
      onSearch(0, 10);
      setIsClearing(false);
    }
  }, [searchTerm, isClearing, onSearch]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onSearch();
    }
  };

  const handleSearchClick = () => {
    onSearch();
  };

  return (
    <div className="searchinput-wrapper">
      <div className="searchinput-container">
        <input
          type="text"
          className="searchinput"
          placeholder={placeholder}
          value={displayValue}
          onChange={handleSearchInputChange}
          onKeyDown={handleKeyPress}
          title={searchTerm} // Add tooltip to show full text on hover
        />
        {searchTerm ? (
          <IoMdClose
            size={22}
            className="searchinput-close-icon"
            onClick={clearSearchAndFetch}
          />
        ) : (
          <img src={searchIcon} alt="Search" className="searchinput-icon" />
        )}
      </div>
      {/* <div>
        <div
          onClick={handleSearchClick}
          className="flte-btnnn"
          style={{ borderRadius: "38px", cursor: "pointer" }}
        >
          Search
        </div>
      </div> */}
      {showSearchButton && (
        <div>
          <div
            onClick={handleSearchClick}
            className="flte-btnnn"
            style={{ borderRadius: "38px", cursor: "pointer" }}
          >
            Search
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchInput;
